import {
  UPSTASH_URL,
  UPSTASH_TOKEN
} from "../Config";

/**
 * Store data in cache
 * @param key - cache key
 * @param value - any JSON serializable data
 * @param ttl - optional time-to-live (in seconds)
 */
export async function cacheSet(key: string, value: any, ttl?: number) {
  try {
    //const serialized = JSON.stringify(value);
    
    // Prepare command arguments
    const args = value;
    if (ttl) {
      args['EX']= ttl.toString();
    }
    
    const response = await fetch(`${UPSTASH_URL}/set/${key}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${UPSTASH_TOKEN}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(args)
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return true;
  } catch (error) {
    console.error(`Failed to set cache for key ${key}:`, error);
    return false;
  }
}

/**
 * Retrieve data from cache
 * @param key - cache key
 * @returns deserialized value or null
 */
export async function cacheGet<T = any>(key: string): Promise<T | null> {
  try {
    const response = await fetch(`${UPSTASH_URL}/get/${key}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${UPSTASH_TOKEN}`
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const result = await response.json();
    const data = result.result;
    console.log(`Cache hit for key ${key}:`, data);
    // remove last 2 items from array
    let originalData = JSON.parse(data);
    if (Array.isArray(originalData) && originalData.length > 2) {
      originalData.pop(); // remove last item
      originalData.pop(); // remove second last item
    }
    return originalData? originalData : null;
  } catch (error) {
    console.error(`Failed to et cache for key ${key}:`, error);
    return null;
  }
}

/**
 * Delete cache entry
 */
export async function cacheDel(key: string) {
  try {
    const response = await fetch(`${UPSTASH_URL}/del`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${UPSTASH_TOKEN}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify([key])
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return true;
  } catch (error) {
    console.error(`Failed to delete cache for key ${key}:`, error);
    return false;
  }
}
